import { Tag } from "antd";
import React from "react";
import {
  SearchWrap,
  SmallButton,
  TagWrap,
  SearchContainer,
} from "static/coreStyles/global.styled";
import { omit, toString } from "lodash";

/** Not shown as grey pills in the search bar; handled by purple tags on list pages or sent only to the API. */
const SEARCH_BAR_HIDDEN_FILTER_KEYS = [
  "page",
  "query",
  "sort",
  "pageSize",
  "userId",
  "userName",
  "groupId",
  "groupName",
  "isVerified",
  "isLiveTrackingEnabledSingleDay",
  "isLiveTrackingEnabledMultiDay",
];

export function Search({
  setSearchTerm,
  onFilterClick,
  filters = {},
  setFilter,
  filterDisabled = false,
  searchDisabled = false,
}) {
  const filtersToUse = omit(filters, SEARCH_BAR_HIDDEN_FILTER_KEYS);
  const searchDisabledStyle = { opacity: 0.65, cursor: "default" };
  return (
    <SearchContainer>
      <SearchWrap style={searchDisabled ? searchDisabledStyle : undefined}>
        <input
          type="text"
          placeholder="Search"
          disabled={searchDisabled}
          style={searchDisabled ? { cursor: "default" } : undefined}
          onChange={(e) => {
            if (!searchDisabled) {
              setSearchTerm(e.target.value);
            }
          }}
        />
        <img src={require("static/images/search.svg")} alt="" />
      </SearchWrap>
      <SmallButton
        type="button"
        disabled={filterDisabled}
        onClick={filterDisabled ? undefined : onFilterClick}
        aria-disabled={filterDisabled}
        style={
          filterDisabled ? { cursor: "default", opacity: 0.65 } : undefined
        }
      >
        <img src={require("static/images/filter.svg")} alt="" />
      </SmallButton>
      <TagWrap>
        {Object.keys(filtersToUse).map((filter) => {
          const name = filter.replace(/([A-Z])/g, " $1").trim();
          return (
            <Tag
              key={filter}
              closable
              style={{ textTransform: "capitalize" }}
              onClose={() => {
                const updatedFilters = omit(filters, filter);
                setFilter(updatedFilters);
              }}
            >
              {name} : {toString(filters[filter])}
            </Tag>
          );
        })}
      </TagWrap>
    </SearchContainer>
  );
}
